import { render } from "./ChangePasswordView.vue?vue&type=template&id=74dc1a97&scoped=true&ts=true"
import script from "./ChangePasswordView.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordView.vue?vue&type=script&lang=ts"

import "./ChangePasswordView.vue?vue&type=style&index=0&id=74dc1a97&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74dc1a97"]])

export default __exports__